import { render, staticRenderFns } from "./FeRatel.vue?vue&type=template&id=26a2b355&"
import script from "./FeRatel.vue?vue&type=script&lang=js&"
export * from "./FeRatel.vue?vue&type=script&lang=js&"
import style0 from "./FeRatel.vue?vue&type=style&index=0&id=26a2b355&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports